import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../lib/helpers/formatters';

export default (props) => {
  const { dealsBudgetsRatio } = props
  const [t] = useTranslation('BUDGET_OFFER_REPORT');
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={dealsBudgetsRatio}
        margin={{
          top: 5, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip formatter={value => formatCurrency(value)} />
        <Legend />
        <Line type="monotone" dataKey="deals" name={t('DEALS')} stroke="#2F4491" />
        <Line type="monotone" dataKey="budget" name={t('BUDGET')} stroke="#FF6B38" />
      </LineChart>
    </ResponsiveContainer>
  );
}
